import { ControlContext } from 'provider/ControlProvider';
import { Fragment, useState, useContext } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ReactComponent as MouseLeft } from 'assets/svg/MouseLeft.svg';
import { ReactComponent as MouseMiddle } from 'assets/svg/MouseMiddle.svg';
import { ReactComponent as MouseRight } from 'assets/svg/MouseRight.svg';
import { ReactComponent as TouchDrag } from 'assets/svg/TouchDrag.svg';
import { ReactComponent as TouchRotate } from 'assets/svg/TouchRotate.svg';
import { ReactComponent as TouchZoom } from 'assets/svg/TouchZoom.svg';
import MapIcon from '@heroicons/react/20/solid/MapIcon';

export default function HelpPanel() {
  const { showModal, setShowModal } = useContext(ControlContext);
  const [mouse, setMouse] = useState(true);
  function closeModal() {
    setShowModal(0);
  }

  return (
    <Transition appear show={showModal === 6} as={Fragment}>
      <Dialog as='div' className='relative z-10' onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black bg-opacity-25' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel className='w-full max-w-md transform  text-left align-middle transition-all'>
                <img
                  src='/assets/bg.png'
                  className='absolute -top-2 md:-top-12 object-cover'
                  alt='Spore&aposs Login Form'
                />
                <div className='py-9 px-4 sm:rounded-lg sm:px-9 relative'>
                  <div className='flex justify-center items-end text-center mb-2 text-xl'>
                    <p className='text-2xl text-zinc-800 font-bold'>Guider</p>
                    <button
                      className='ml-2 hover:text-red-500'
                      onClick={(e) => {
                        e.preventDefault();
                        setMouse(true);
                      }}
                      style={{ color: mouse ? '#B16706' : '#363636' }}
                    >
                      Mouse
                    </button>
                    <p>/</p>
                    <button
                      className='hover:text-red-500'
                      onClick={(e) => {
                        e.preventDefault();
                        setMouse(false);
                      }}
                      style={{ color: !mouse ? '#B16706' : '#363636' }}
                    >
                      Touch
                    </button>
                  </div>
                  {mouse ? (
                    <div className='mx-16 space-y-3'>
                      <div className='flex justify-start items-center'>
                        <MouseLeft className='h-16 w-16' />
                        <div>
                          <h2 className='font-bold text-xl text-zinc-700'>
                            Pan View
                          </h2>
                          <p>Left Click + Drag</p>
                        </div>
                      </div>
                      <div className='flex justify-start items-center'>
                        <MouseMiddle className='h-16 w-16' />
                        <div>
                          <h2 className='font-bold text-xl text-zinc-700'>
                            Zoom View
                          </h2>
                          <p>Mouse wheel scroll</p>
                        </div>
                      </div>
                      <div className='flex justify-start items-center'>
                        <MouseRight className='h-16 w-16' />
                        <div>
                          <h2 className='font-bold text-xl text-zinc-700'>
                            Rotate View
                          </h2>
                          <p>Right Click + Drag</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className='mx-16 space-y-3'>
                      <div className='flex justify-start items-center'>
                        <TouchDrag className='w-16 h-16 ' />
                        <div>
                          <h2 className='font-bold text-xl text-zinc-700'>
                            Pan View
                          </h2>
                          <p>Left Click + Drag</p>
                        </div>
                      </div>
                      <div className='flex justify-start items-center'>
                        <TouchZoom className='w-16 h-16' />
                        <div>
                          <h2 className='font-bold text-xl text-zinc-700'>
                            Zoom View
                          </h2>
                          <p>Mouse wheel scroll</p>
                        </div>
                      </div>
                      <div className='flex justify-start items-start'>
                        <TouchRotate className='w-16 h-16' />
                        <div>
                          <h2 className='font-bold text-xl text-zinc-700'>
                            Rotate View
                          </h2>
                          <p>Right Click + Drag</p>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='flex mx-20 mt-8 justify-start items-center'>
                    <p>---</p>
                    <MapIcon className='w-6 text-white mr-2' />
                    <p>Reset Camera------</p>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
